<template>
  <div>
    <div class="page-header d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <router-link :to="{ name: 'credit_auth' }">
          <button class="btn btn-control">
            <img src="@/assets/icons/bold-icon previous.svg" alt="Return back">
          </button>
        </router-link>
        <h3 class="page-header-title ms-2">Request Credit Auth</h3>
      </div>
    </div>
    <div class="page-content p-0">
      <div class="text-center mt-5" v-if="ui.loading">
        <div class="spinner-border mt-5" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <div class="row w-100" v-else>
        <!--  Preview  -->
        <div class="col-md-8 border-right-light">
          <vue-html2pdf
            :show-layout="false"
            :float-layout="true"
            :enable-download="true"
            :preview-modal="false"
            :paginate-elements-by-height="1400"
            filename="hee hee"
            :pdf-quality="2"
            :manual-pagination="false"
            pdf-format="a4"
            pdf-orientation="portrait"
            ref="html2Pdf"
          >
            <section slot="pdf-content">
              <credit-auth-preview :docsData="docData"/>
            </section>
          </vue-html2pdf>
        </div>

        <div class="col-md-4 pt-4 pe-4 ps-4">
          <!--  Success alert for request  -->
          <div class="col-12 request-done" v-if="!ui.edit">
            Request sent on {{ this.formatDate(docData.requestSentOn, 'ddd h:ss A, MMM D YYYY') }}
          </div>
          <div>
            <div class="col-title d-flex align-items-center">
              <span>Participant Details</span>
              <button class="btn btn-control ms-2" @click="ui.edit = true">
                <img src="@/assets/icons/icon-edit-normal.svg" alt="">
              </button>
            </div>

            <!--  Show before send request  -->
            <div class="row mt-3" v-if="ui.edit">
              <div class="col-6">
                <div class="form-group">
                  <label for="firstNameField">First Name</label>
                  <input type="text" v-model="docData.firstName" id="firstNameField"
                         class="form-control" :class="{ 'input-danger': getFirstError('firstName', errors) }">
                  <p v-if="getFirstError('firstName', errors)">{{ getFirstError('firstName', errors) }}</p>
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label for="lastNameField">Last Name</label>
                  <input type="text" v-model="docData.lastName" id="lastNameField"
                         class="form-control" :class="{ 'input-danger': getFirstError('lastName', errors) }">
                  <p v-if="getFirstError('firstName', errors)">{{ getFirstError('lastName', errors) }}</p>
                </div>
              </div>
              <div class="col-12 mt-3">
                <div class="form-group w-100 full-width">
                  <label for="addressField">Address</label>
                  <input type="text" v-model="docData.address" id="addressField" class="form-control" :class="{ 'input-danger': getFirstError('address', errors) }">
                  <p v-if="getFirstError('firstName', errors)">{{ getFirstError('address', errors) }}</p>
                </div>
              </div>
              <div class="row mt-3 w-100 p-0 m-auto">
                <div class="col-6">
                  <div class="form-group">
                    <label for="cityField">City</label>
                    <input type="text" v-model="docData.city" class="form-control" id="cityField" :class="{ 'input-danger': getFirstError('city', errors) }">
                    <p v-if="getFirstError('firstName', errors)">{{ getFirstError('city', errors) }}</p>
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label for="stateField">State</label>
                    <input type="text" v-model="docData.state" class="form-control" id="stateField" :class="{ 'input-danger': getFirstError('state', errors) }">
                    <p v-if="getFirstError('firstName', errors)">{{ getFirstError('state', errors) }}</p>
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group">
                    <label for="zipField">Zip</label>
                    <input type="text" v-model="docData.zip" class="form-control" id="zipField" :class="{ 'input-danger': getFirstError('zip', errors) }">
                    <p v-if="getFirstError('firstName', errors)">{{ getFirstError('zip', errors) }}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 mt-3">
                <div class="form-group full-width w-100">
                  <label for="emailField">Email Address</label>
                  <input type="text" v-model="docData.email" class="form-control" id="emailField" :class="{ 'input-danger': getFirstError('email', errors) }">
                  <p v-if="getFirstError('firstName', errors)">{{ getFirstError('email', errors) }}</p>
                </div>
              </div>
              <div class="col-12 mt-3">
                <base-button title="Save" action="secondary-default" @click-btn="saveData" :loading="ui.saving" />
              </div>
            </div>

            <!--  Show after send request  -->
            <div class="mt-3" v-else>
              <div class="table">
                <table class="table">
                  <tbody>
                  <tr>
                    <td>First Name</td>
                    <td>{{ docData.firstName }}</td>
                  </tr>
                  <tr>
                    <td>Last Name</td>
                    <td>{{ docData.lastName }}</td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>{{ docData.address }}</td>
                  </tr>
                  <tr>
                    <td>City</td>
                    <td>{{ docData.city }}</td>
                  </tr>
                  <tr>
                    <td>State</td>
                    <td>{{ docData.state }}</td>
                  </tr>
                  <tr>
                    <td>Zip</td>
                    <td>{{ docData.zip }}</td>
                  </tr>
                  <tr>
                    <td>Email Address</td>
                    <td>{{ docData.email }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <base-button title="Remind" action="secondary" @click-btn="remind" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CreditAuthPreview from "../preview/CreditAuthPreview";
import VueHtml2pdf from 'vue-html2pdf';
import BaseButton from '../../../components/BaseButton.vue';
export default {
  name: 'CreditAuthDetailsRequest',
  components: {CreditAuthPreview, VueHtml2pdf, BaseButton},
  data() {
    return {
      ui: {
        loading: false,
        edit: false,
        saving: false
      },
      docData: {
        firstName: null,
        lastName: null,
        email: null,
        status: null,
        requestSentOn: null,
        documentSignedOn: null,
        address: null,
        city: null,
        state: null,
        zip: null,
        signature: null
      },
      errors: []
    }
  },
  beforeMount() {
    this.getData()
  },
  methods: {
    getData() {
      this.ui.loading = true
      this.$http.get(`/api/v1/credit-auth/details/${this.$route.params.uuid}`)
        .then(response => {
          this.docData = response.data.doc
          this.ui.loading = false
        })
    },
    saveData() {
      this.ui.saving = true
      this.$http.post(`/api/v1/credit-auth/update/${this.$route.params.uuid}`, this.docData)
        .then(response => {
          this.docData = response.data.doc
          this.ui.saving = false
          this.ui.edit = false
          this.pushAlert('success', 'Participant data updated successfully')
        })
        .catch(error => {
          this.errors = error.response.data.errors
        })
    },
    remind() {
      if (confirm('Send remind email?')) {
        this.$http.get(`/api/v1/credit-auth/remind/${this.$route.params.uuid}`)
          .then(() => {
            this.pushAlert('success', 'Email reminder sent successfully')
          })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.border-right-light {
  border-right: 1px solid #e7e8e8;
  @media screen and (max-width: 568px) {
    border: none;
  }
}

.col-title {
  color: #000000;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 21px;
}

.form-group {
  label {
    color: rgba(0, 0, 0, .7);
    font-size: 12px;
    letter-spacing: 0;
    line-height: 12px;
  }

  input {
    height: 36px;
    border: 1px solid #D4D4D4;
    border-radius: 4px;
    background-color: #FFFFFF;
  }

  p {
    color: #D20A3B;
    font-size: 10px;
    letter-spacing: 0;
    line-height: 18px;
    margin: 0;
  }
}

.request-done {
  padding: 11px 18px 11px 18px;
  margin-bottom: 24px;
  color: #000000;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 24px;
  border: 1px solid rgba(0, 215, 104, 0.4);
  border-radius: 4px;
  background-color: rgba(0, 215, 104, 0.1);
}

.table {
  tr {
    td {
      height: 36px;
      padding: 10px 12px;

      &:first-child {
        color: rgba(0, 0, 0, .7);
        font-size: 13px;
        letter-spacing: 0;
        line-height: 18px;
        font-weight: normal;
      }

      color: #000000;
      font-size: 13px;
      letter-spacing: 0;
      line-height: 18px;
      font-weight: normal;
    }
  }
}

button {
  &.btn-outline-grey {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 32px;
    width: fit-content;
    padding: 0 21.5px;
    color: rgba(0, 0, 0, .7);
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 14px;
    border-radius: 8px;
    border: 1px solid #8A8A8A;
    transition: all .3s;

    &:hover {
      background: #eeeeee;
    }
  }

  &.btn-primary {
    min-width: 120px;
  }
}

#pdf-generate {
  max-width: 791px;
  width: 100%;
  height: 1000px;
}

.vue-html2pdf::v-deep {

  .content-wrapper {
    margin: 30px auto;
  }

  .layout-container {
    position: initial !important;
    width: inherit !important;
    height: initial !important;
    background: none !important;
  }
}
</style>
